(()=>{
  'use strict';
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const turkey=document.querySelector('.ez-harvest-turkey');
  let timer;
  let firstFlight=true;
  const stop=()=>{
    clearTimeout(timer);
    turkey?.classList.remove('is-flying');
  };
  const schedule=()=>{
    if(!turkey||motion.matches||document.hidden)return;
    clearTimeout(timer);
    const delay=firstFlight?7000+Math.random()*5000:42000+Math.random()*28000;
    timer=setTimeout(()=>{
      if(motion.matches||document.hidden)return;
      firstFlight=false;
      turkey.style.setProperty('--ez-flight-height',`${45+Math.random()*23}vh`);
      turkey.classList.add('is-flying');
    },delay);
  };
  const update=()=>{
    document.body.classList.toggle('ez-effects-paused',motion.matches);
    stop();
    schedule();
  };
  turkey?.addEventListener('animationend',event=>{
    if(event.target!==turkey)return;
    turkey.classList.remove('is-flying');
    schedule();
  });
  motion.addEventListener('change',update);
  document.addEventListener('visibilitychange',update);
  update();
})();
